// Global guard for unsaved changes (used by the Site builder + Layout navigation).
let current = null; // { isDirty: () => bool, open: (proceed) => void }

export function setLeaveGuard(g) { current = g; }
export function clearLeaveGuard(g) { if (current === g) current = null; }

// If there are unsaved changes, hand the proceed callback to the guard and
// return true (caller must NOT navigate itself). Otherwise return false.
export function tryLeave(proceed) {
  if (current && current.isDirty && current.isDirty()) {
    current.open(proceed);
    return true;
  }
  return false;
}
